import { ReservationListInterface } from "../../store/slices/reservationSlice";
import { useTypedSelector } from "../../store/store";

import AirwallexProvider from "./providers/airwallex";
import AuthorizeProvider from "./providers/authorize";
import DirectProvider from "./providers/direct";
import StripeProvider from "./providers/stripe";

export type PaymentRenderMode = "page" | "modal";

export interface PaymentBillingDetails {
  name?: string;
  email?: string;
  phone?: string;
  address?: {
    city?: string;
    country?: string;
    line1?: string;
    line2?: string;
    postal_code?: string;
    state?: string;
  };
}

export interface PaymentProviderRendererProps {
  mode?: PaymentRenderMode;
  amount?: number;
  currency?: string;
  pnr?: string;
  source?: string;
  billingDetails?: PaymentBillingDetails;
  reservation?: ReservationListInterface;
  onSuccess?: () => void;
  onFail?: (message?: string) => void;
  hideTitleAndPriceType?: boolean;
}

function PaymentProviderRenderer({
  mode = "page",
  amount,
  currency,
  pnr,
  source,
  onSuccess,
  onFail,
  hideTitleAndPriceType,
  reservation,
}: PaymentProviderRendererProps) {
  const { payment_provider } = useTypedSelector((state) => state.environment);

  switch (payment_provider) {
    case "stripe": {
      return (
        <StripeProvider
          mode={mode}
          amount={amount}
          currency={currency}
          pnr={pnr}
          source={source}
          onSuccess={onSuccess}
          onFail={onFail}
          hideTitleAndPriceType={hideTitleAndPriceType}
          reservation={reservation}
        />
      );
    }

    case "authorize": {
      return (
        <AuthorizeProvider
          mode={mode}
          amount={amount}
          currency={currency}
          pnr={pnr}
          source={source}
          onSuccess={onSuccess}
          onFail={onFail}
          hideTitleAndPriceType={hideTitleAndPriceType}
        />
      );
    }

    case "airwallex": {
      return (
        <AirwallexProvider
          mode={mode}
          amount={amount}
          currency={currency}
          pnr={pnr}
          source={source}
          onSuccess={onSuccess}
          onFail={onFail}
          hideTitleAndPriceType={hideTitleAndPriceType}
        />
      );
    }

    case "direct": {
      return (
        <DirectProvider
          mode={mode}
          amount={amount}
          currency={currency}
          pnr={pnr}
          source={source}
          onSuccess={onSuccess}
          onFail={onFail}
          hideTitleAndPriceType={hideTitleAndPriceType}
        />
      );
    }

    default: {
      return (
        <DirectProvider
          mode={mode}
          amount={amount}
          currency={currency}
          pnr={pnr}
          source={source}
          onSuccess={onSuccess}
          onFail={onFail}
          hideTitleAndPriceType={hideTitleAndPriceType}
        />
      );
    }
  }
}

export default PaymentProviderRenderer;
